// Example enterprise systems Aivio's agents can work with, by business area. Shown on the use-cases
// page and in the hero walkthrough; actual connections depend on each customer's environment.
const integrationGroups = [
  { label: "SALES & CRM", apps: ["Salesforce", "Dynamics 365 Sales", "HubSpot", "Salesloft"] },
  { label: "PROCUREMENT & ERP", apps: ["SAP Ariba", "SAP S/4HANA", "Coupa", "Oracle Fusion"] },
  { label: "FINANCE", apps: ["Dynamics 365 Finance and Operations", "Oracle Fusion", "IBM Planning Analytics", "BlackLine"] },
  { label: "CUSTOMER SERVICE", apps: ["ServiceNow", "Zendesk", "Twilio Flex"] },
  { label: "COLLABORATION", apps: ["Microsoft Teams", "Microsoft Outlook", "Microsoft SharePoint", "Slack", "Google Drive", "Box"] },
  { label: "PEOPLE OPERATIONS", apps: ["Workday", "SAP SuccessFactors", "Oracle HCM", "Greenhouse"] },
  { label: "IT & SERVICE MANAGEMENT", apps: ["ServiceNow", "Jira Service Management", "Microsoft Entra ID"] },
  { label: "CONTRACTS & SIGNATURE", apps: ["DocuSign", "Adobe Acrobat Sign", "Microsoft SharePoint"] },
  { label: "BANKING & INSURANCE", apps: ["Infosys Finacle", "Temenos", "Guidewire ClaimCenter", "Duck Creek"] },
  { label: "LIFE SCIENCES & QUALITY", apps: ["Veeva Vault", "Oracle Argus Safety", "ArisGlobal LifeSphere", "MasterControl"] },
  { label: "MAINTENANCE & FIELD SERVICE", apps: ["IBM Maximo", "SAP Plant Maintenance", "ServiceNow Field Service Management"] },
  { label: "RISK & COMPLIANCE", apps: ["IBM OpenPages", "ServiceNow GRC", "MetricStream"] },
];

export default integrationGroups;
